import { palette } from 'styled-tools'

const bgOptions = {
  white: palette('white'),
  black: palette('black'),
  grey: palette('backgroundAlt'),
}

export default function getBgColor(color) {
  switch (color) {
    case 'normal':
    case false:
      return bgOptions.white
    case 'isInverse':
    case true:
      return bgOptions.black
    default:
      if (!bgOptions[color]) {
        return console.error('No such colour exists')
      }

      return bgOptions[color]
  }
}



// WEBPACK FOOTER //
// ./includes/yoco-website-cms-gatsby/src/utils/styling/backgroundOptions.js